import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import IndexStyle from './style.scss';
import Buttons from './buttons';
import C_APP from '../../constants/app';
import styled from 'styled-components';
import intlC from '../../constants/intl';
import Search from './search';
import { bindActionCreators } from 'redux';
import * as SearchActions from '../../actions/search';
import * as scActions from '../../actions/serviceCatalog';
import C from '../../constants/search';

const StyledToolBarWrapper = styled.div`
  background-color: ${(props) => props.theme.toolbarBackground};
`;

class Toolbar extends React.Component {
  render() {
    const showIncidentButton =
      this.props.permissionsData.reportIssueEnabled &&
      this.props.preferences.enableIncidentSubmitBtn;
    const showSrButton =
      this.props.permissionsData.submitRequestEnabled &&
      this.props.preferences.enableRequestSubmitBtn;
    const showAIButton =  this.props.permissionsData.aienabled;
    const searchDisplay = this.props.permissionsData.searchEnabled ? (
      <Search
        intlObject={this.props.intlObject}
        actions={this.props.searchActions}
        searchKeyword={this.props.searchKeyword}
      />
    ) : (
      false
    );
    return (
      <StyledToolBarWrapper className={IndexStyle.toolbarWrapper}>
        <Grid fluid>
          <Row>
            <Col lgOffset={1} lg={3} sm={5}>
              {searchDisplay}
            </Col>
            <Col lg={7} sm={7}>
              <Buttons
                showIncidentButton={showIncidentButton}
                showSrButton={showSrButton}
                showAIButton={showAIButton}
                intlObject={this.props.intlObject}
                actions={this.props.serviceCatalogActions}
              />
            </Col>
          </Row>
        </Grid>
      </StyledToolBarWrapper>
    );
  }
}

Toolbar.propTypes = {
  permissionsData: PropTypes.object.isRequired,
  intlObject: PropTypes.object.isRequired,
  searchActions: PropTypes.object.isRequired,
  searchKeyword: PropTypes.string.isRequired,
  preferences: PropTypes.object.isRequired,
  serviceCatalogActions: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    permissionsData: state.app.getIn([C_APP.SSP_PERMISSIONS_LIST]),
    intlObject: state.intl.get(intlC.INTL_OBJECT),
    searchKeyword: state.Search.get(C.SEARCH_KEYWORD),
    preferences: state.app.getIn([C_APP.SSP_PREFERENCES])
  };
}

function mapDispatchToProps(dispatch) {
  return {
    searchActions: bindActionCreators(SearchActions, dispatch),
    serviceCatalogActions: bindActionCreators(scActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar);



// WEBPACK FOOTER //
// ./components/Toolbar/index.js